import { gql } from '@apollo/client';

export const GET_WINE_MATRIX_FILTERS = gql`
  query GetWineMatrixFilters(
    $from: Int
    $pageSize: Int
    $wineName: String
    $filters: WineMatrixFilters
    $tab: String!
  ) {
    getWineMatrixFilters(from: $from, pageSize: $pageSize, wineName: $wineName, filters: $filters, tab: $tab) {
      country
      region
      producer
      classification
      tier
      bottlePrice
      wsGrade
      liquidity
      score
    }
  }
`;
